import { useEffect, useState } from 'react'
import ProgressionService from '../../../services/api/ProgressionService'

// Fetches section details on demand (when drawer opens). Date range changes
// Trigger a re-fetch via the dependency array.
const useSectionDetails = ({ collectId, draftId, sectionId, dateRange, resourceIds }) => {
  const [details, setDetails] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!sectionId) {
      setDetails(null)
      return () => null
    }
    let cancelled = false
    const guard = handler => result => {
      if (!cancelled)
        handler(result)
    }
    setDetails(null)
    setLoading(true)
    setError(null)
    ProgressionService.fetchSectionDetails(collectId, draftId, {
      sectionId,
      resourceIds,
      startDate: dateRange?.startDate,
      endDate: dateRange?.endDate
    })
      .then(guard(setDetails))
      .catch(guard(setError))
      .finally(guard(() => setLoading(false)))
    return () => { cancelled = true }
  }, [collectId, draftId, sectionId, dateRange?.startDate, dateRange?.endDate, resourceIds])

  return { details, loading, error }
}

export default useSectionDetails
